import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import ImageModule from "docxtemplater-image-module-free";
import { base64ADatos } from "./assessmentExtractor";
import { MONEDAS } from "./propuestaComercialGenerator";
import { obtenerDimensionesImagen, ajustarProporcional } from "./imageDimensions";

const RUTA_MACHOTE = `${process.env.PUBLIC_URL || ""}/documentos/Machote_propuesta_economica.docx`;

const RUTAS_LOGO_EMPRESA = {
  Netjer: `${process.env.PUBLIC_URL || ""}/img/NJ-Logotipo.png`,
  Rexten: `${process.env.PUBLIC_URL || ""}/img/rexten.png`,
};

const NOMBRES_EMPRESA = {
  Netjer: "Netjer Networks México",
  Rexten: "Rexten",
};

const NOMBRES_EMPRESA_LEGAL = {
  Netjer: "Netjer Networks México S.A. de C.V.",
  Rexten: "Rexten Global Communications S.A. de C.V.",
};

const MONEDA_DEFAULT = "USD";

const PIXEL_TRANSPARENTE_BASE64 = "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";

const cargarLogoEmpresa = async (empresa) => {
  const ruta = RUTAS_LOGO_EMPRESA[empresa] || RUTAS_LOGO_EMPRESA.Netjer;
  const respuesta = await fetch(ruta);
  if (!respuesta.ok) {
    throw new Error(`No se pudo cargar el logo de la empresa (${ruta}).`);
  }
  return new Uint8Array(await respuesta.arrayBuffer());
};

const TAMANO_MAXIMO_LOGO_CLIENTE_PORTADA = [220, 220];
const TAMANO_MAXIMO_LOGO_EMPRESA_ENCABEZADO = [130, 95];

const TAMANOS_MAXIMOS_POR_TAG = {
  logoCliente: TAMANO_MAXIMO_LOGO_CLIENTE_PORTADA,
  logoEmpresaEncabezado: TAMANO_MAXIMO_LOGO_EMPRESA_ENCABEZADO,
};

const crearModuloImagenes = () =>
  new ImageModule({
    centered: false,
    fileType: "docx",
    getImage: (tagValue) => tagValue,
    getSize: (imgBuffer, _tagValue, tagName) => {
      const tamanoMaximo = TAMANOS_MAXIMOS_POR_TAG[tagName] || TAMANO_MAXIMO_LOGO_CLIENTE_PORTADA;
      return ajustarProporcional(obtenerDimensionesImagen(imgBuffer), tamanoMaximo);
    },
  });

const marcasCronogramaCompletas = (marcas) => {
  const completas = {};
  for (let f = 1; f <= 7; f += 1) {
    for (let s = 1; s <= 7; s += 1) {
      const clave = `cronP${f}S${s}`;
      completas[clave] = (marcas && marcas[clave]) || "";
    }
  }
  return completas;
};

export const generarDocumentoPropuestaEconomica = async ({
  nombreProyecto,
  fechaCreacion,
  nombreRazonSocial,
  contactoCliente,
  puestoContactoCliente,
  logoCliente,
  empresa,
  bomFilas,
  marcasCronograma,
  firmante,
  moneda,
  tieneIVA,
  tieneBom,
  tieneCronograma,
}) => {
  const [respuesta, datosLogoEmpresa] = await Promise.all([
    fetch(RUTA_MACHOTE),
    cargarLogoEmpresa(empresa),
  ]);
  if (!respuesta.ok) {
    throw new Error(
      "No se pudo cargar el machote de Propuesta Económica (public/documentos/Machote_propuesta_economica.docx)."
    );
  }
  const arrayBuffer = await respuesta.arrayBuffer();
  const zip = new PizZip(arrayBuffer);

  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
    nullGetter: () => "",
    modules: [crearModuloImagenes()],
  });

  const datosLogoCliente = logoCliente
    ? base64ADatos(logoCliente.base64)
    : base64ADatos(PIXEL_TRANSPARENTE_BASE64);

  const datosMoneda = MONEDAS[moneda] || MONEDAS[MONEDA_DEFAULT];

  try {
    await doc.renderAsync({
      nombreProyecto,
      fechaCreacion,
      nombreRazonSocial: nombreRazonSocial || "",
      contactoCliente: contactoCliente || "",
      puestoContactoCliente: puestoContactoCliente || "",
      nombreEmpresa: NOMBRES_EMPRESA[empresa] || empresa,
      nombreEmpresaLegal: NOMBRES_EMPRESA_LEGAL[empresa] || empresa,
      logoCliente: datosLogoCliente,
      logoEmpresaEncabezado: datosLogoEmpresa,
      bomFilas: bomFilas && bomFilas.length > 0 ? bomFilas : [{ col1: "", col2: "", col3: "" }],
      ...marcasCronogramaCompletas(marcasCronograma),
      tieneBom: Boolean(tieneBom),
      tieneCronograma: Boolean(tieneCronograma),
      tieneIVA: Boolean(tieneIVA),
      monedaCodigo: datosMoneda.codigo,
      monedaTextoPago: datosMoneda.textoPago,
      nombreFirmante: firmante.nombre,
      puestoFirmante: firmante.puesto,
      correoFirmante: firmante.correo,
      celularFirmante: firmante.celular,
    });
  } catch (error) {
    const detalle = error.properties && error.properties.errors
      ? error.properties.errors.map((e) => e.message).join("; ")
      : error.message;
    throw new Error(`No se pudo generar la Propuesta Económica a partir del machote: ${detalle}`);
  }

  return doc.toBlob();
};
